export default "__VITE_ASSET__bbec6c13__"